import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendProductQuotation, } from '../Actions/ProductInfo.action';
import { translate } from '../Services/translation';
import Modal from 'react-modal';

const QuotationButtonContainer = (props) => {

    const dispatch = useDispatch();

    const [visible, setVisible] = useState(false);

    const [articleNumber, setArticleNumber] = useState(props.productId ?? '');
    const [articleName, setArticleName] = useState(props.productName ?? '');
    const [customerName, setCustomerName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerCompanyName, setCustomerCompanyName] = useState('');
    const [customerAddress, setCustomerAddress] = useState('');
    const [customerDeliveryAddress, setCustomerDeliveryAddress] = useState('');
    const [customerMessage, setCustomerMessage] = useState('');
    const [acceptedTerms, setTerms] = useState(false);

    const mailSelector = useSelector((state) => state.mailProduct);

    const handleSubmitEmail = (event) => {
        event.preventDefault();

        const data = {
            articleNumber,
            articleName,
            customerName,
            customerEmail,
            customerPhone,
            customerCompanyName,
            customerAddress,
            customerDeliveryAddress,
            customerMessage,
            acceptedTerms
        };

        dispatch(sendProductQuotation(data));
    };

    const customStyles = {
        content: {
            width: "fit-content",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
        },
        overlay: {
            background: 'rgba(0, 0, 0, 0.8)',
            zIndex: 2003,

        },
    };

    const fields = [
        {
            id: "articleNumber",
            value: articleNumber,
            onChange: setArticleNumber,
            required: false
        },
        {
            id: "articleName",
            value: articleName,
            onChange: setArticleName,
            required: true
        },
        {
            id: "customerName",
            value: customerName,
            onChange: setCustomerName,
            required: true
        },
        {
            id: "customerEmail",
            value: customerEmail,
            onChange: setCustomerEmail,
            required: true,
            type: "email"
        },
        {
            id: "customerPhone",
            value: customerPhone,
            onChange: setCustomerPhone,
            required: true
        },
        {
            id: "customerCompanyName",
            value: customerCompanyName,
            onChange: setCustomerCompanyName,
            required: false
        },
        {
            id: "customerAddress",
            value: customerAddress,
            onChange: setCustomerAddress,
            required: false
        },
        {
            id: "customerDeliveryAddress",
            value: customerDeliveryAddress,
            onChange: setCustomerDeliveryAddress,
            required: false
        },
        {
            id: "customerMessage",
            value: customerMessage,
            onChange: setCustomerMessage,
            required: false,
            tagType: "textarea"
        }
    ]

    return (
        <div>
            <button
                onClick={() => {
                    setVisible(true);
                }
                }
                className={
                    `${"buy-button product-quotation__buy-btn"} ${!mailSelector.isLoading
                        && !mailSelector.isSuccessful
                        && mailSelector.haveResponded
                        ? " error"
                        : ""}`
                }
            >

                {ActionStatusMessage(
                    mailSelector.isLoading,
                    mailSelector.isSuccessful,
                    mailSelector.haveResponded)}

            </button>

            <Modal
                ariaHideApp={false}
                preventScroll={true}
                isOpen={visible}
                onRequestClose={() => setVisible(false)}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
            >
                <QuotationForm
                    onMailSubmit={handleSubmitEmail}
                    response={props.mailResponse}
                    setVisible={() => setVisible(false)}
                    fields={fields}
                    terms={{
                        value: acceptedTerms,
                        onChecked: setTerms,
                        link: props.quotationTerms
                    }}
                />
            </Modal>
        </div>
    );
};

const QuotationForm = (props) => {

    const termsTranslation = translate("product.quotation.termstext");
    const termsLinkTranslation = translate("product.quotation.termslinktext");

    return (
        <form
            onSubmit={(e) => {
                props.onMailSubmit(e);
                props.setVisible(false);
            }}
            className="product-quotation__forms-container"
        >
            <button
                onClick={() => props.setVisible(false)}
                className="product-quotation__close-btn"
            >
                &times;
            </button>

            <h1 className="product-quotation__name" itemProp="name">{translate("product.quotation.title")}</h1>

            {props.fields.map(field => InputField(field.id.toLowerCase(), field.value, field.onChange, field.required, field.tagType, field.type))}

            <div className="product-quotation__forms-container__form-control">
                <div className="product-quotation__terms-container">
                    <input
                        className="product-quotation__terms-container__checkbox"
                        id="quotationTerms"
                        name="quotationTerms"
                        type="checkbox"
                        checked={props.terms.value}
                        onChange={(event) => props.terms.onChecked(event.target.checked)}
                        required={true}
                    />
                    <label className="product-quotation__terms-container__label">
                        {termsTranslation.includes("{0}")
                            ? termsTranslation.replace("{0}", termsLinkTranslation)
                            : <span>{termsTranslation} <a href={props.terms.link} target="_blank" rel="noreferrer noopener" className="link-with-underline">{termsLinkTranslation}</a></span>
                        }
                    </label>
                </div>
            </div>

            <div>
                <button className="product-quotation__button confirm" type="submit">
                    {translate('product.actions.submit-button-text')}
                </button>
            </div>
        </form>
    );
};

const InputField = (id, value, onChange, required = false, tagType = "input", type = "text") => {
    return (
        <div key={id} className="product-quotation__forms-container__form-control">
            <label className="form__labdotnet rel" htmlFor={id}>
                {translate(`product.quotation.${id}`)}
            </label>
            {tagType === "input" && <input
                className="form__input"
                id={id}
                name={id}
                type={type}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                required={required}
            />}
            {tagType === "textarea" && <textarea
                className="form__input"
                id={id}
                name={id}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                required={required}
            />}
        </div>
    );
}

const ActionStatusMessage = (isLoading, isSuccessful, haveResponded) => {
    if (isLoading) {
        return translate('product.actions.quotation.loading-message')
    } else if (!isLoading && isSuccessful && haveResponded) {
        return translate('product.actions.quotation.success-message');
    } else if (!isLoading && !isSuccessful && haveResponded) {
        return translate('product.actions.quotation.failed-message');
    }
    return translate('product.actions.quotation.button');
};

export default QuotationButtonContainer;
